module.exports = __webpack_public_path__ + "img/308.9ac20f81.png";